module.exports = __webpack_public_path__ + "img/frame (210).b1328e68.jpg";